import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { PAGE_SIZE } from '~/modules/common/const';
import { useGetKeyValueSettings } from '~/modules/common/hooks';
import { ResourceAllocationStatus } from '~/types';

const ALLOCATION_STATUS_LIST = [
  ResourceAllocationStatus.Committed,
  ResourceAllocationStatus.Proposed,
  ResourceAllocationStatus.Rejected
];

export const GET_RESOURCE_PLAN_FILTER_USERS_QUERY = gql`
  query GetResourceUsersWithResourceAllocationsOrActualsForProject(
    $projectUri: String!
    $limit: Int!
    $filter: ResourceUsersWithResourceAllocationsOrActualsForProjectFilter
  ) {
    resourceUsersWithResourceAllocationsOrActualsForProject(
      projectUri: $projectUri
      limit: $limit
      filter: $filter
    ) {
      users {
        id
        displayText
      }
      hasMore
    }
  }
`;

export const mapResourcePlanFilterUsers = users =>
  (users || []).map(user => ({
    id: user.id,
    value: user.id,
    label: user.displayText,
    displayText: user.displayText,
    key: user.displayText
  }));

export const useResourcePlanFilterUsers = (projectUri, searchTerm) => {
  const { keyValueSettings: chartSettings } = useGetKeyValueSettings(
    'resource_plan_chart_settings'
  );
  const showActuals = chartSettings?.showActuals || false;

  const { data, loading } = useQuery(GET_RESOURCE_PLAN_FILTER_USERS_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      projectUri,
      limit: PAGE_SIZE,
      filter: {
        searchText: searchTerm,
        allocationStatusList: ALLOCATION_STATUS_LIST,
        excludeActualUsers: !showActuals
      }
    },
    skip: !projectUri,
    context: {
      debounceKey: 'resource-plan-user-filter-key',
      debounceTimeout: 250
    }
  });

  const result = data?.resourceUsersWithResourceAllocationsOrActualsForProject;

  return {
    users: mapResourcePlanFilterUsers(result?.users),
    hasMore: result?.hasMore ?? false,
    loading
  };
};
